export default "__VITE_PUBLIC_ASSET__b257fe01__"